// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxOutlinedSvg from "@fishx/icons-svg/es/asn/CodeSandboxOutlined";
import FishxIcon from '../components/FishxIcon';

var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxOutlinedSvg
  }));
};

CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
export default React.forwardRef(CodeSandboxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeSandboxOutlined.js
// module id = 2274
// module chunks = 0